import * as React from 'react';

export interface TabProps {
  name: string;
  title: string;
  children: React.ReactNode | React.ReactNodeArray;
  disabled?: boolean;
}

export type TabComponent = React.ComponentElement<TabProps, any>;

/**
 * This component collects tab data and renders content
 * @param {TabProps} props
 * @constructor
 */
function Tab(props: TabProps): React.ReactElement<TabProps> {
  return <>{props.children}</>;
}

export default React.memo(Tab);
